<template>
	<dashboard-dropdown-section
		title="Upcoming Bookings"
		class="mt-4"
		type="practice-upcoming-bookings"
		:items-shown="5"
		:items="bookings"
		event-name="load-practice-upcoming-bookings"
		@load-practice-upcoming-bookings="loadMore"
	/>
</template>

<script>
import { mapActions } from 'vuex';

import DashboardDropdownSection from '@/components/custom/DashboardDropdownSection';

export default {
	name: 'PracticeUpcomingBookings',

	components: { DashboardDropdownSection },

	data: () => ({
		bookings: [],
	}),

	methods: {
		...mapActions('bookings', ['FetchCompanyBookings']),

		async loadMore(event) {
			const { startDate, endDate } = event;

			const bookings = await this.FetchCompanyBookings({ startDate, endDate });
			this.bookings = bookings.map(booking => ({ ...booking, event_start_date: booking.start_date }));
		},
	},
};
</script>
